module.exports = __webpack_public_path__ + "img/additional_btn.bf59ce8a.png";